﻿import React, { useState, useEffect } from 'react';
import CustomModal from '../../../components/Global/CustomModal/CustomModal';
import Text from '@mui/material/TextField';
import { GetProducerClaim } from '../../../api/home';
import { useQuery } from '@tanstack/react-query';

export default function ProducerProxy() {
  const divStyle = {
    cursor: 'pointer',
    textDecoration: 'underline',
  };

  const [showChange, setShowChange] = useState(false);
  const [prodID, setProdID] = useState('');
  const handleShowChange = () => setShowChange(true);
  const handleHideChange = () => setShowChange(false);

  const ChangeProxy = () => {
    window.location.reload();
  };

  const getProducerClaim = useQuery({
    queryKey: ['getProducerClaim', 0],
    queryFn: async () => await GetProducerClaim()(),
  });

  // Handle getProducerClaim success
  useEffect(() => {
    if (getProducerClaim.isSuccess && getProducerClaim.data) {
      setProdID(JSON.parse(getProducerClaim.data.prodID));
    }
  }, [getProducerClaim.isSuccess, getProducerClaim.data]);

  return (
    <>
      <div onClick={handleShowChange} style={divStyle}>
        Change Producer
      </div>
      <CustomModal
        show={showChange}
        onHide={handleHideChange}
        title="Change Producer Proxy"
        body={
          <Text
            id="standard-basic"
            label="Producer"
            value={prodID}
            onChange={(e) => setProdID(e.target.value)}
          />
        }
        buttonOne={
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              ChangeProxy();
            }}
          >
            Change Producer
          </button>
        }
        buttonTwo={
          <button className="btn btn-default" type="button" onClick={handleHideChange}>
            Close
          </button>
        }
        buttonThree={null}
      />
    </>
  );
}
